



import {email, required, minLength, maxLength, minValue, maxValue, sameAs, between, numeric, helpers} from "vuelidate/lib/validators";
const alphaNum = helpers.regex('alphaNum', /^[a-zA-Z0-9- ]+$/)
import FormButton from "@/components/main/buttons/FormButton";
import SpinnerButton from "@/components/main/buttons/SpinnerButton";
import FormInput from "@/components/main/forms/FormInput";
import FormSelect from "@/components/main/forms/FormSelect";
import FormSelectAuth from "@/components/main/forms/FormSelectAuth";

import datingforparents from "@/assets/images/main/form-logos/datingforparents.png"
import hearts from "@/assets/images/main/form-logos/hearts.png"
import jdate from "@/assets/images/main/form-logos/jdate.svg"
import lavalife from "@/assets/images/main/form-logos/lavalife.png"
import lovoo from "@/assets/images/main/form-logos/lovoo.svg"
import mico from "@/assets/images/main/form-logos/mico.png"
import okcupid from "@/assets/images/main/form-logos/okcupid.png"
import zoosk from "@/assets/images/main/form-logos/zoosk.png"
import Spinner from "@/components/main/popups/Spinner";
import CheckBoxRed from "@/components/main/core/CheckBoxRed"
import DashModalBuy from "@/components/dashboard/DashModalBuy";
import VueCountryDropdown from 'vue-country-dropdown'
import {mask} from 'vue-the-mask'
import 'epic-spinners/dist/lib/epic-spinners.min.css'
import { LoopingRhombusesSpinner } from 'epic-spinners/dist/lib/epic-spinners.min.js'
import isMob768 from "@/mixins/isMob";

import VueCountryCode from "vue-country-code";
import "@/plugins/vuelidate"
import validationErrors from "@/mixins/validationErrors";

export default {
  name: "SingInForm",
  mixins: [isMob768, validationErrors],
  components: {FormButton, SpinnerButton, FormInput, FormSelect, FormSelectAuth, Spinner, CheckBoxRed, DashModalBuy, LoopingRhombusesSpinner, VueCountryCode, VueCountryDropdown},

  directives: {mask},

  data() {
    return {

      coupon_code: '',
      utm: '',

    //  plans: '', //ПЛАН КОТОРЫЙ БУДЕТ ПЕРЕДАН ВО ВТОРОЙ СТЕПС, ОПРЕДЕЛЯЕТСЯ В MOUNTED

      locstep: '1',

      logos: [
        {
          img: hearts
        },
        {
          img: jdate
        },
        {
          img: datingforparents
        },
        {
          img: lovoo
        },
        {
          img: mico
        },
        {
          img: lavalife
        },
        {
          img: okcupid
        },
        {
          img: zoosk
        },

      ],
//------FORM----------
      firstName: '',
      lastName: '',
      email: '',
      country_hint: '',
      phone: '',
      pass: '',
      confirmPass: '',
      formMale: 1,
      formAge: 1,
      formStatus: 1,

      planWasSelected: 1,

      cardNumber: '',

      billingAddress1: '',
      billingAddress2: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      mm: '',
      yy: '',
      cvv: '',
      captchaResponse: '',
      date: new Date(),
      nowYear: 22,
      arterYear: '',
      radar_session_id: null,
      ipAddress: null,


// ---------------------------



      str: [], // for spliting first and last names
      isCheckboxChecked: true,
      test: false,
      isCheckboxCheckedStep3: false,
      testStep3: false,

      freePlan: false,

      price: '',

      spinnerOn: false,
      showModal: false,

      currentStep: 1,
      captchaChecked: false,
      emailchecked: false,
      ischeckchecked: false,
      msg: '',
      registerError: false,

      male: [
        {
          name: 'Male',
          id: 1
        },
        {
          name: 'Female',
          id: 2
        },
      ],
      age: [
        {
          name: '18-25',
          id: 1,
        },
        {
          name: '26-35',
          id: 2,
        },
        {
          name: '36-50',
          id: 3,
        },
        {
          name: '50+',
          id: 4,
        }
      ],
      status: [
        {
          name: 'Single',
          id: 1
        },
        {
          name: 'In Relationship',
          id: 2
        },
        {
          name: 'Married',
          id: 3
        },
        {
          name: 'Divorced',
          id: 4
        },
        {
          name: 'Engaged',
          id: 5
        },
        {
          name: 'Separated',
          id: 6
        },
      ],
      plansDatingSocial: [

        {
          id: null,
          name: 'Flex Search Credits',
          price: null
        },

        {
          id: 5,
          name: 'FLEX PACKAGE (1) EMAIL/PROFILE SEARCH CREDIT ',
          price: '9.99'
        },

        {
          id: 6,
          name: 'FLEX PACKAGE (3) EMAIL/PROFILE SEARCH CREDIT ',
          price: '19.99'
        },

        {
          id: 7,
          name: 'FLEX PACKAGE (5) EMAIL/PROFILE SEARCH CREDIT ',
          price: '29.99'
        },

        {
          id: null,
          name: 'Monthly Plan',
          price: null
        },

        {
          id: 11,
          name: 'MONTHLY (2) DAILY EMAIL/PROFILE SEARCHES ',
          price: '49.99'
        },

        {
          id: 12,
          name: 'MONTHLY (3) DAILY EMAIL/PROFILE SEARCHES ',
          price: '75.99'
        },

        {
          id: 13,
          name: 'MONTHLY (4) DAILY EMAIL/PROFILE SEARCHES ',
          price: '99.99'
        },

        {
          id: null,
          name: 'Ultimate Plan',
          price: null
        },

        {
          id: 26,
          name: 'ULTIMATE (60) SEARCH CREDITS BUNDLED ACROSS ALL OUR SERVICES ',
          price: '99.99'
        },
      ],
      plansXXXcams: [
        {
          id: null,
          name: 'XXX Flex Search Credits',
          price: null
        },

        {
          id: 17,
          name: 'XXX PACKAGE (1) EMAIL/PROFILE SEARCH CREDIT ',
          price: '14.99'
        },

        {
          id: 18,
          name: 'XXX PACKAGE (3) EMAIL/PROFILE SEARCH CREDIT ',
          price: '24.99'
        },

        {
          id: 19,
          name: 'XXX PACKAGE (5) EMAIL/PROFILE SEARCH CREDIT ',
          price: '34.99'
        },

        {
          id: null,
          name: 'XXX Monthly Plan',
          price: null
        },

        {
          id: 20,
          name: 'XXX MONTHLY (2) DAILY EMAIL/PROFILE SEARCHES ',
          price: '49.99'
        },

        {
          id: 21,
          name: 'XXX MONTHLY (3) DAILY EMAIL/PROFILE SEARCHES ',
          price: '75.99'
        },

        {
          id: 22,
          name: 'XXX MONTHLY (4) DAILY EMAIL/PROFILE SEARCHES ',
          price: '99.99'
        },

        {
          id: null,
          name: 'Ultimate Plan',
          price: null
        },

        {
          id: 26,
          name: 'ULTIMATE (60) SEARCH CREDITS BUNDLED ACROSS ALL OUR SERVICES ',
          price: '99.99'
        },
      ],
      plansTinder: [
        {
          id: null,
          name: 'Tinder Blaster Credits',
          price: null
        },

        {
          id: 2,
          name: 'TINDER BLASTER (3) TINDER SEARCH CREDIT ',
          price: '14.99'
        },

        {
          id: 3,
          name: 'TINDER BLASTER (5) TINDER SEARCH CREDIT ',
          price: '19.99'
        },

        {
          id: 4,
          name: 'TINDER BLASTER (10) TINDER SEARCH CREDIT ',
          price: '29.99'
        },

        {
          id: null,
          name: 'Ultimate Plan',
          price: null
        },

        {
          id: 26,
          name: 'ULTIMATE (60) SEARCH CREDITS BUNDLED ACROSS ALL OUR SERVICES ',
          price: '99.99'
        },
      ],
      plansLocator: [
        {
          id: null,
          name: 'Listing Locator Credits',
          price: null
        },

        {
          id: 8,
          name: 'LISTING LOCATOR (1) PEOPLE/PHONE/ADDRESS/EMAIL LOOKUP ',
          price: '7.99'
        },

        {
          id: 9,
          name: 'LISTING LOCATOR (3) PEOPLE/PHONE/ADDRESS/EMAIL LOOKUP ',
          price: '15.99'
        },

        {
          id: 10,
          name: 'LISTING LOCATOR (5) PEOPLE/PHONE/ADDRESS/EMAIL LOOKUP ',
          price: '24.99'
        },

        {
          id: null,
          name: 'Ultimate Plan',
          price: null
        },

        {
          id: 26,
          name: 'ULTIMATE (60) SEARCH CREDITS BUNDLED ACROSS ALL OUR SERVICES ',
          price: '99.99'
        },
      ],
      step2checks: {
        dating: [
          'Catch A Cheating Partner',
          'See If Partner Is Active Online',
          'Protect Yourself From Players',
          'Remove Doubt & Save Time',
          'Ensure Relationship Safety',
          'Eliminate Relationship Insecurity'
        ],
        xxxCams: [
          'Catch A Cheating Partner',
          'Learn What Turns Your Partner On ',
          'Know More About Your Partner',
          'Stop Budget Leaks',
          'Save Your Relationship',
          'See If Partner Is Active Online',
        ],
        ll: [
          'Verify Personal Info & Family Status',
          'Catch A Cheating Partner',
          'ID Unknown Calls Or Texts',
          'Verify The Identity Of Someone New',
          'Protect Yourself From Scammers',
          'Feel Secure In Your Relationship'
        ],
        tinder: [
          'Catch A Cheating Partner',
          'Discover Recent Activity',
          'Save Yourself From Heartbreak',
          'Learn More About Your Partner',
          'Feel Secure In Your Relationship'
        ]
      },
      step2checksReturn: '',
      step2optionsReturn: '',

      step2options: {
        flex: {
          name: 'Flex Search Credits',
          options: [
            'Dating/Alternative LifeStyles Sites',
            'Social Media & Mobile Chat/Hook-Up Apps'
          ]
        },
        monthly: {
          name: 'Monthly Plan',
          options: [
            'Dating/Alternative LifeStyles Sites',
            'Social Media & Mobile Chat/Hook-Up Apps'
          ]
        },
        ultimate: {
          name: 'Ultimate Plan',
          options: [
            'Dating/Alternative LifeStyles Sites',
            'Social Media & Mobile Chat/Hook-Up Apps',
            'Listing Locator',
            'Live Adult Streams ',
            'XXX Websites',
            'Tinder Blaster'
          ]
        },
        ListingLocator: {
          name: 'Listing Locator Plan',
          options: [
            'People Look Up',
            'Phone Look Up',
            'Address Look Up',
            'Email Look Up',
          ]
        },
        TinderBlaster: {
          name: 'Tinder Blaster Plan',
          options: [
            'Tinder'
          ]
        }
      }
    }
  },
  validations() {
    return {
      firstName: {required, minLength: minLength(3)},
      lastName: {required, minLength: minLength(3)},
      email: {
        required,
        email: value => {
          if (/\s/.test(value)) {
            return false;
          }
          const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
          return emailRegex.test(value);
        }
      },
      phone: {minLength: minLength(9)},
      pass: {required, minLength: minLength(6),
        containsAtLeastOneNumber() {
          const numberRegex = /\d/;
          return numberRegex.test(this.pass);
        }
      },
      confirmPass: {required, sameAsPassword: sameAs('pass')},
      cardNumber: {required, minLength: minLength(17), maxLength: maxLength(23)},
      billingAddress1: {required, minLength: minLength(4)},
      billingAddress2: {minLength: minLength(2)},
      city: {required, minLength: minLength(2)},
      state: {
        required: function(value) {
          return this.country !== 'United States' || !!value
        },
        minLength: function(value) {
          return this.country !== 'United States' || minLength(1)(value)
        }
      },
      zip: {
        required: function(value) {
          return this.country !== 'United States' || !!value
        },
        minLength: function(value) {
          return this.country !== 'United States' || minLength(5)(value)
        },
        alphaNum: function(value) {
          return this.country !== 'United States' || !value || alphaNum(value)
        }
      },
      country: {required, minLength: minLength(2)},
      mm: {required, minLength: minLength(2), between: between(1, 12), numeric},
      yy: {required, minLength: minLength(2), maxLength: maxLength(2), minValue: minValue(Number(String(this.date.getFullYear()).substr(2, 2))), maxValue: maxValue(Number(String(this.date.getFullYear()).substr(2, 2)) + 10), numeric},
      cvv: {required, minLength: minLength(2), maxLength: maxLength(4), numeric},
      coupon_code: {minLength: minLength(6), maxLength: maxLength(6)},
    }
  },

  computed: {
    formData() {
      return ({

        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        pass: this.pass,
        confirmPass: this.confirmPass,
        formMale: this.formMale,
        formAge: this.formAge,
        formStatus: this.formStatus,

        planWasSelected: this.planWasSelected,

        cardNumber: this.cardNumber,

        billingAddress1: this.billingAddress1,
        billingAddress2: this.billingAddress2,
        city: this.city,
        state: this.state,
        zip: this.zip,
        country: this.country,
        mm: this.mm,
        yy: this.yy,
        cvv: this.cvv,
        captchaResponse: this.captchaResponse
      })
    },

    allOk() {

      return (
        this.firstName.length >= 3 &&
        this.lastName.length >= 3 &&
        this.email.length >= 4 &&
        // this.phone.length >= 8 &&
        this.pass.length >= 6 &&
        this.confirmPass.length >= 6 &&
        this.pass === this.confirmPass 
        // && this.isCheckboxChecked && !this.emailchecked
      )
    },

    allOkStep3() {
      const isUS = this.country === 'United States'
      
      if (!(this.cardNumber.length === 23 || this.cardNumber.length === 19 || this.cardNumber.length === 18 || this.cardNumber.length === 17)) return false
      if (this.billingAddress1.length < 3) return false
      if (this.city.length < 2) return false
      if (this.mm.length < 1) return false
      if (this.yy.length !== 2) return false
      if (this.cvv.length < 3) return false
      
      if (isUS) {
        if (!this.state || this.state.length < 1) return false
        if (!this.zip || this.zip.length < 5) return false
      }
      
      if (this.$v.cardNumber.$error) return false
      if (this.$v.billingAddress1.$error) return false
      if (this.$v.city.$error) return false
      if (this.$v.mm.$error) return false
      if (this.$v.yy.$error) return false
      if (this.$v.cvv.$error) return false
      
      if (isUS) {
        if (this.$v.state.$error) return false
        if (this.$v.zip.$error) return false
      }
      
      if (this.coupon_code && (this.coupon_code.length !== 6 || this.$v.coupon_code.$error)) return false
      
      return true
    },
    isUSCountry() {
      return this.country === 'United States'
    },
    stepTitle() {
      switch (+this.locstep) {
        case 1:
          return '1. ACCOUNT DETAILS'
        case 2:
          return '2. plan details'
        case 3:
          return '3. payment details'
      }
    },
    selectedPlanName() {
      if (!this.planWasSelected || this.planWasSelected === 1) {
        return 'FLEX PACKAGE (1) EMAIL/PROFILE SEARCH CREDIT - $9.99';
      }
      const allPlans = [
        ...this.plansDatingSocial,
        ...this.plansXXXcams,
        ...this.plansTinder,
        ...this.plansLocator
      ];
      const selectedPlan = allPlans.find(plan => plan.id === this.planWasSelected);
      return selectedPlan ? selectedPlan.name : 'FLEX PACKAGE (1) EMAIL/PROFILE SEARCH CREDIT - $9.99';
    },

  },

  watch: {
    isCheckboxChecked() {
      if (this.isCheckboxChecked === true) this.ischeckchecked = true;
    },

    planWasSelected() {
      switch (this.planWasSelected) {
        case 5:
        case 6:
        case 7:
          this.step2optionsReturn = this.step2options.flex;
          break;
        case 11:
        case 12:
        case 13:
        case 20:
        case 21:
        case 22:
          this.step2optionsReturn = this.step2options.monthly;
          break;
        case 26:
          this.step2optionsReturn = this.step2options.ultimate;
          break;
        case 8:
        case 9:
        case 10:
          this.step2optionsReturn = this.step2options.ListingLocator;
          break;
        case 2:
        case 3:
        case 4:
          this.step2optionsReturn = this.step2options.TinderBlaster;
          break;

        default: return this.step2optionsReturn = '';
      }
    },
    country: function() {
      if (this.$v.state) {
        this.$v.state.$reset()
      }
      if (this.$v.zip) {
        this.$v.zip.$reset()
      }
    }
  },
  mounted() {
    this.umt = this.$store.state.userModule.utm
    if(this.$store.state.userModule.coupon) {
      this.coupon_code = this.$store.state.userModule.coupon
    }
    //Подставляем план c query, который по умолчанию 1
    this.planWasSelected = +this.$route.query.plan;
    this.productWasSelected = +this.$route.query.product;



    //Проверяем какой план и присваиваем "this.free" план статус бесплатный план или нет.
    +this.$route.query.plan > 1 && +this.$route.query.plan < 27 ? this.freePlan = false : this.freePlan = true;



    //роверяем цену по умолчанию во втором степсе (до открытия выпадающего меню)
    if (this.$route.query.plan && +this.$route.query.plan != 1) {
      let tempPlan = this.plans().find(item => item.id === +this.$route.query.plan)
      this.price = tempPlan.price;
    }

    // Get user's IP and radar_session Stripe
    this.$getIpAddress()
      .then((ipAddress) => {
        this.ipAddress = ipAddress;

        // Create radar session and get radar_session_id
        return this.$createRadarSession();
      })
      .then(({ radarSession, error }) => {
        if (error) {
          console.error('Failed to create radar session:', error);
        } else {
          this.radar_session_id = radarSession.id;
          // console.log('radar_session_id:', this.radar_session_id);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  },


  created() {


    if (this.$store.state.stepsUser.clientsEmail) {
      this.email = this.$store.state.stepsUser.clientsEmail
    }

    if (this.$store.state.stepsUser.clientsName) {

      this.str = this.$store.state.stepsUser.clientsName.split(" ");
      if (this.str[0]) {this.firstName = this.str[0].toString()}
      if (this.str[1]) {this.lastName = this.str[1].toString()}


      this.price = parseInt(this.price)

    }
  },

  beforeDestroy() {
    this.firstName = ''
    this.lastName = ''
    this.email = ''
  },

  methods: {

    selectCode({name, iso2, dialCode}) {
      this.country_hint = `+${dialCode}`
    },

    twitterGet() {

      let self = this;
      this.$axios.get(`${process.env.API_BASE_URL}/api/auth/login/twitter`, {

      })
        .then(function (response) {
          let resp = response.data
          let lnk = resp.replace('free%3D0', 'free%3D1')
          window.location.href = lnk
        })

        .catch(function (error) {
          console.log('error: ' + error);
        });
    },

    facebookGet() {
      let self = this;
      this.$axios.get(`${process.env.API_BASE_URL}/api/auth/login/facebook`, {

      })
        .then(function (response) {
          let resp = response.data
          let lnk = resp.replace('free%3D0', 'free%3D1')
          window.location.href = lnk
        })

        .catch(function (error) {
          console.log('error: ' + error);
        });
    },

    googleGet() {
      let self = this;
      this.$axios.get(`${process.env.API_BASE_URL}/api/auth/login/google`, {

      })
        .then(function (response) {
          let resp = response.data
          let lnk = resp.replace('free%3D0', 'free%3D1')
          window.location.href = lnk
        })

        .catch(function (error) {
          console.log('error: ' + error);
        });
    },

    linkedGet() {
      let self = this;
      this.$axios.get(`${process.env.API_BASE_URL}/api/auth/login/linkedin`, {

      })
        .then(function (response) {
          let resp = response.data
          let lnk = resp.replace('free%3D0', 'free%3D1')
          window.location.href = lnk
        })

        .catch(function (error) {
          console.log('error: ' + error);
        });
    },

    signin(email, password, remember, accept_terms) {
      this.test = true
      let self = this;
        this.$axios.post(`${process.env.API_BASE_URL}/api/auth/login/`, {
          email: email,
          password: password,
          remember: remember,
          accept_terms: accept_terms,
        })
          .then(function (response) {
            if (response.data.access_token) {
              localStorage.setItem('token', response.data.access_token);

              self.$store.commit('userModule/SET_IS_LOGGED')

              if (self.$store.state.userModule.utm && !self.registerError) {
                self.sendUtm()
              }
                localStorage.setItem('visitedRegisterPage', 'true');
                self.$router.push('/account/welcome');
            }
          })
          .catch(function (error) {
            console.log('error: ' + error);
          });
    },

    async submit() {
      this.ischecked = true;
      this.spinnerOn = true;
      this.captchaResponse = await this.$recaptcha.getResponse();
      let self = this;

      this.$axios.post(`${process.env.API_BASE_URL}/api/auth/register/`, {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        phone: this.phone ? this.country_hint + this.phone : '',
        password: this.pass,
        password_confirmation: this.confirmPass,
        gender_id: this.formMale,
        age_range_id: this.formAge,
        material_status_id: this.formStatus,
        accept_terms: 1,
        coupon_code: this.coupon_code,
        plan_credit_cards: this.planWasSelected,

        card_number: this.cardNumber,
        exp_month: this.mm,
        exp_year: this.yy,
        cvc: this.cvv,
        address: this.billingAddress1,
        address2: this.billingAddress2,
        city: this.city,
        state: this.state,
        zip: this.zip,
        country: this.country,
        'g-recaptcha-response': this.captchaResponse,
        utm: this.utm,
        user_ip: this.ipAddress,
        radar_session_id: this.radar_session_id
      })
        .then(function (response) {
          if (response.data.access_token) {
            localStorage.setItem('token', response.data.access_token);
            self.$store.commit('userModule/SET_IS_LOGGED');
          }
          if (response.data.payment_error) {
            self.$notify({
              group: 'main',
              title: 'Error',
              text: response.data.payment_error,
              type: 'error',
              speed: 1000,
              duration: 10000,
            });
            return;
          }
          const pd = response.data.payment_data;
          const paymentSuccess = pd && (pd.transaction_id || (pd.id && pd.status === 'succeeded'));
          self.sendTransactionData(response.data.payment_data);
          if (paymentSuccess) {
            localStorage.setItem('visitedRegisterPage', 'true');
            self.$router.push('/thankyou');
          } else {
            if (process.client && typeof window != "undefined") {
              self.signin(self.email, self.pass, true, 1)
            }
            self.locstep = '1'
            localStorage.setItem('step', self.locstep)
          }
        })
        .catch(function (error) {
          if (error.response && error.response.status === 422 || error.response.status === 500) {
            self.displayValidationErrors(error.response);
          } else {
            console.error(error);
          }
        })
        .finally(function () {
          self.spinnerOn = false;
          self.refreshCaptcha();
        });
    },

    sendTransactionData(transactionData) {
      if (transactionData && process.env.APP_ENV === 'production') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'purchase',
          ecommerce: {
            transaction_id: transactionData.transaction_id,
            affiliation: "ifindCheaters",
            value: transactionData.value,
            currency: "USD",
            coupon: transactionData.coupon,
            items: [
              {
                item_name: transactionData.items.item_name,
                item_id: transactionData.items.item_id,
                price: transactionData.items.price,
                item_brand: "ifindCheaters",
                item_category: transactionData.items.item_category,
                quantity: transactionData.items.quantity
              }
            ]
          }
        });
      }
    },

    showNotify() {
      this.$emit('showNotify', this.msg)
    },

    sendUtm() {
      let self = this
      this.$axios.setHeader('Authorization', `bearer ${localStorage.getItem('token')}`, ['post'])
      this.$axios.post(`${process.env.API_BASE_URL}/api/account/set_cookie`, {

        plan_id: this.planWasSelected,
        coupon_code: this.coupon_code,
        gclid: this.$store.state.userModule.utm.gclid ? this.$store.state.userModule.utm.gclid : '',
        referral: this.$store.state.userModule.utm.referral ? this.$store.state.userModule.utm.referral : '',
        utm_funnel: this.$store.state.userModule.utm.utm_funnel ? this.$store.state.userModule.utm.utm_funnel : '',
        utm_source: this.$store.state.userModule.utm.utm_source ? this.$store.state.userModule.utm.utm_source : '',
        utm_campaign: this.$store.state.userModule.utm.utm_campaign ? this.$store.state.userModule.utm.utm_campaign : '',
        utm_medium: this.$store.state.userModule.utm.utm_medium ? this.$store.state.userModule.utm.utm_medium : '',
        utm_term: this.$store.state.userModule.utm.utm_term? this.$store.state.userModule.utm.utm_term : '',
        utm_content: this.$store.state.userModule.utm.utm_content? this.$store.state.userModule.utm.utm_content : '',
      })
        .then(function (response) {
          // console.log('sendUTM = ', response.data)
          if (self.planWasSelected !== 1) {
            self.$store.commit('userModule/DEL_UTM')
            self.$store.commit('userModule/DEL_COUPON')
            self.coupon_code = ''
          }

        })
        .catch(function (error) {
          console.log('error: ' + error);
          self.spinnerOn = false
          self.showModal = false
        });
    },

//Проверяем с каким продуктом перешел юзер и соответственно передаем план во второй степс
    plans() {
      switch (+this.$route.query.plan) {
        case 1:
        case 2:
        case 3:
        case 4:
          this.step2checksReturn = this.step2checks.tinder
          return this.plansTinder;

        case 5:
        case 6:
        case 7:
        case 11:
        case 12:
        case 13:
        case 14:
        case 26:
          this.step2checksReturn = this.step2checks.dating
          return this.plansDatingSocial;

        case 8:
        case 9:
        case 10:
          this.step2checksReturn = this.step2checks.ll
          return this.plansLocator;

        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
        case 22:
        case 23:
        case 24:
        case 25:
          this.step2checksReturn = this.step2checks.xxxCams
          return this.plansXXXcams;

        default: return this.plansDatingSocial;
      }
    },

    async nextStep() {
      let self = this
      this.$axios.post(
        `${process.env.API_BASE_URL}/api/auth/check_email/`,
        { user_email: this.email }
      )
      .then(function (response) {
        if (response.data !== 1 ) {
          self.msg = "The email has already been taken, please try another."
          self.locstep = 1
          self.showNotify()
        }
      })
      .catch(function (error) {
        console.log('error ' + error);
      });

      this.isCheckboxChecked ? this.ischeckchecked = true : this.ischeckchecked = false

      if (!this.$v.email.$error && this.locstep < 3 && this.isCheckboxChecked === true) {
        this.locstep++
        this.emailchecked = false
      }
    },
    next2Step() {
      if (this.locstep < 3) {
        this.locstep++
      }
    },
    prevStep() {
      if (this.locstep > 0) {
        this.msg = ''
        this.locstep--
      }
    },
//Подставляем цену возле плана
    makeChoice(id, price) {
      this.planWasSelected = id
      switch (id) {
        case 0:
          this.price = '0';
          this.freePlan = true
          break;
        case 1:
          this.price = '9';
          this.freePlan = false
          break;
        case 2:
          this.price = '19';
          this.freePlan = false
          break;
        case 3:
          this.price = '29';
          this.freePlan = false
          break;
        case 5:
          this.price = '49';
          this.freePlan = false
          break;
        case 6:
          this.price = '75';
          this.freePlan = false
          break;
        case 7:
          this.price = '99';
          this.freePlan = false
          break;

        case 8:
          this.price = '7';
          this.freePlan = false
          break;

        case 9:
          this.price = '15';
          this.freePlan = false
          break;

        case 10:
          this.price = '24';
          this.freePlan = false
          break;

        case 14:
        case 26:
          this.price = '99';
          this.freePlan = false
          break;
      }
      this.price = parseInt(price)
    },
    makeChoiceMale(id) {
      this.formMale = id
    },
    makeChoiceAge(id) {
      this.formAge = id
    },
    makeChoiceStatus(id) {
      this.formStatus = id
    },

    onSelect(country) {
      this.country = country.name
      if (this.$v.state) {
        this.$v.state.$reset()
      }
      if (this.$v.zip) {
        this.$v.zip.$reset()
      }
    },

    changeCaptchaChecked() {
      this.captchaChecked = true;
    },
    onExpired() {
      this.captchaChecked = false;
    },
    refreshCaptcha() {
      this.$recaptcha.reset();
      this.captchaChecked = false;
      this.captchaResponse = null;
    },
    showBuyModal() {
      this.testStep3 = true;
      if (!this.isCheckboxCheckedStep3) {
        return;
      }
      if (this.$v.coupon_code.$error) {
        return;
      }
      this.showModal = true;
    },
    toggleModal(is) {
      is ? this.showModal = is : this.showModal = false
    },
  }
}
